export default __webpack_public_path__ + "static/media/TV_Justica.fee26c3e.jpg";